module.exports = __webpack_public_path__ + "static/media/pratik.a1aab39e.jpeg";